export default "__VITE_ASSET__BHF3sD1V__"